import React from "react";
import { useNavigate } from "react-router-dom";
import { Page } from "../../components";
import styles from "./styles.module.css";

type Card = {
  title: string;
  description: string;
  action: string;
  onClick: () => void;
};

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const cards: Card[] = [
    {
      title: "View Agencies",
      description: "Manage agencies, see usage, and export data.",
      action: "Go to Agencies",
      onClick: () => navigate("/agencies"),
    },
    {
      title: "Running Workflows",
      description: "Review running/stuck/failed workflows, mark failed, or login as user to retry.",
      action: "Open Workflows",
      onClick: () => navigate("/workflows"),
    },
    {
      title: "Export Data",
      description: "Export agency data in CSV format with policies count and workflow counts for a specific date range.",
      action: "Export Data",
      onClick: () => navigate("/export-data"),
    },
    {
      title: "Usage Metrics",
      description: "Track usage trends, compare periods, and drill into per-agency or per-user activity by category.",
      action: "View Usage",
      onClick: () => navigate("/metrics"),
    },
    {
      title: "Software Costs",
      description: "What we're billed by AWS, Anthropic, MongoDB and other vendors each month.",
      action: "View Costs",
      onClick: () => navigate("/costs"),
    },
    {
      title: "Internal Sales Metrics",
      description: "View sales rep activity: new accounts booked, account notes, and pipeline updates with charts and filters.",
      action: "View Metrics",
      onClick: () => navigate("/sales-metrics"),
    },
    {
      title: "Issue Tracking",
      description: "Visualize Linear issues classified by LLM-generated categories with trend charts and history.",
      action: "View Issues",
      onClick: () => navigate("/issue-tracking"),
    },
    {
      title: "Pull Requests",
      description: "Open PRs across the org: yours, ones waiting on your review, and everyone else's.",
      action: "View PRs",
      onClick: () => navigate("/pull-requests"),
    },
  ];

  return (
    <Page>
      {/* Header Section */}
      <div className={styles.headerContainer}>
        <h1 className={styles.title}>Admin Console</h1>
        <p className={styles.subtitle}>
          Quick access to common tools: agency management, stuck workflows, and data export. More modules can be added later.
        </p>
      </div>

      {/* Cards Section */}
      <div className={styles.contentContainer}>
        <div className={styles.grid}>
          {cards.map((card) => (
            <div key={card.title} className={styles.card}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{card.title}</h3>
              </div>
              <p className={styles.cardBody}>{card.description}</p>
              <button className={styles.cardButton} onClick={card.onClick}>
                {card.action}
              </button>
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default HomePage;

